import { render, staticRenderFns } from "./AlarmInfo.vue?vue&type=template&id=6ff8387e&scoped=true"
import script from "./AlarmInfo.vue?vue&type=script&lang=js"
export * from "./AlarmInfo.vue?vue&type=script&lang=js"
import style0 from "./AlarmInfo.vue?vue&type=style&index=0&id=6ff8387e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8387e",
  null
  
)

export default component.exports